import React from "react";
import { sanitizeHTML } from "../../../../../../utils/htmlSanitizer";

type PreOrderItemType = {
  name?: string;
  description?: string;
  customer?: string;
};

const PreOrderItem = ({ name, description, customer }: PreOrderItemType) => {
  return (
    <div>
      {name && <div dangerouslySetInnerHTML={{ __html: sanitizeHTML(name) }} />}
      {description && (
        <div dangerouslySetInnerHTML={{ __html: sanitizeHTML(description) }} />
      )}
      {customer && <div>{customer}</div>}
    </div>
  );
};

export default PreOrderItem;
